import { TrialPeriodDays } from 'hydra-data-types';
import moment from 'moment';

/** The trial end date as a formatted string, for example `'March 5, 2023'`.  */
export function trialPeriodEndDate(
  trialPeriodDays: TrialPeriodDays,
  format = 'MMMM D, YYYY'
): string {
  return moment().add(trialPeriodDays, 'day').format(format);
}
